import React, { Component } from 'react'
import styled from 'styled-components';
import BarGraph from './BarGraph';

class BarChart extends Component {
  render() {
    const { data, label, labelName, unit } = this.props;
    
    return (
      <Container>
        <BarGraph data={data} label={label} labelName={labelName} unit={unit}/>
      </Container> 
    );
  }
}
const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-size: 12px;
`;

export default BarChart;